/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface GraduatoriaResiduoDTO { 
    id?: string;
    nome?: string;
    confermata_il?: string;
    residuo_budget?: number;
    residuo_posti?: number;
    disponibile?: boolean;
    motivo_non_disponibile?: string;
}

